/* @jsx h */
import { defineComponent, h } from "vue";
import type { RestaurantProfileData } from "../types";

export const ContactInfoSection = defineComponent<{
  data: RestaurantProfileData;
  onUpdate: <K extends keyof RestaurantProfileData>(field: K, value: RestaurantProfileData[K]) => void;
}>({
  name: "ContactInfoSection",
  props: ["data", "onUpdate"],
  setup(props) {
    return () => (
      <div class="bg-base-100 l-box-shadow  rounded-xl p-6 shadow-sm border ">
        <div class="flex items-center gap-3 mb-6">
          <div class="w-10 h-10 rounded-lg bg-info/10 flex items-center justify-center">
            <span class="material-symbols-outlined text-info text-xl">contact_mail</span>
          </div>
          <div>
            <h3 class="text-lg font-semibold text-accent">Contact Information</h3>
            <p class="text-sm text-base-content/60">How customers can reach you</p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-base-content/80 mb-2">Contact Person *</label>
            <div class="relative">
              <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-base-content/40 text-lg">
                person
              </span>
              <input
                type="text"
                value={props.data.contact_person}
                onInput={(e) => props.onUpdate("contact_person", (e.target as HTMLInputElement).value)}
                class="input input-bordered w-full bg-base-200 focus:bg-base-100 transition-colors pl-10"
                placeholder="John Doe"
                required
              />
            </div>
          </div>

          <div>
            <label class="block text-sm font-medium text-base-content/80 mb-2">Email Address *</label>
            <div class="relative">
              <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-base-content/40 text-lg">
                mail
              </span>
              <input
                type="email"
                value={props.data.email}
                onInput={(e) => props.onUpdate("email", (e.target as HTMLInputElement).value)}
                class="input input-bordered w-full bg-base-200 focus:bg-base-100 transition-colors pl-10"
                placeholder="contact@restaurant.com"
                required
              />
            </div>
          </div>

          <div>
            <label class="block text-sm font-medium text-base-content/80 mb-2">Phone Number *</label>
            <div class="relative">
              <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-base-content/40 text-lg">
                phone
              </span>
              <input
                type="tel"
                value={props.data.phone}
                onInput={(e) => props.onUpdate("phone", (e.target as HTMLInputElement).value)}
                class="input input-bordered w-full bg-base-200 focus:bg-base-100 transition-colors pl-10"
                placeholder="+41 44 123 45 67"
                required
              />
            </div>
          </div>
        </div>
      </div>
    );
  },
});
